(function ($, Drupal, drupalSettings) {
  'use strict';

  function IEObjectFit(bgImageClassName, containerClassName) {
    var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    var isIEEdge = window.navigator.userAgent.indexOf('Edge') > -1;

    if (isIE11 === true || isIEEdge === true) {
      $(bgImageClassName).each(function () {
        var container = $(this);
        var imgUrl = container.find('img').prop('src');
        if (imgUrl) {
          container.css('backgroundImage', 'url(' + imgUrl + ')').addClass('compat-object-fit');
        }
      });
      $(containerClassName).each(function () {
        var container = $(this);
        var imgUrl = container.find('img').prop('src');
        if (imgUrl) {
          container.css('backgroundImage', 'url(' + imgUrl + ')').addClass('compat-object-fit');
        }
      });
    }
  }

  Drupal.behaviors.randomReviewIcon = {
    attach: function (context, settings) {
      $('.kr-kid-name-age-info-wrapper').each(function () {
        var random = Math.floor((Math.random() * 4) + 1);
        if (random === 1) {
          $(this).addClass('duck');
        }
        else if (random === 2) {
          $(this).addClass('bear');
        }
        else if (random === 3) {
          $(this).addClass('frog');
        }
        else if (random === 4) {
          $(this).addClass('fox');
        }
      });
    }
  };

  Drupal.behaviors.preFooterCtaStyle = {
    wrappedStyles: function () {
      $('.kr-partner-prefooter__cta-wrapper a').each(function () {
        var ctaHeight = $(this).outerHeight();
        var ctaMax = 50;

        if (ctaHeight >= ctaMax) {
          $(this).addClass('wrapped');
        }
      });
    },
    attach: function (context, settings) {
      $('.kr-partner-prefooter__cta-wrapper a', context).each(function () {
        Drupal.behaviors.preFooterCtaStyle.wrappedStyles();
        window.addEventListener('resize', function () {
          Drupal.behaviors.preFooterCtaStyle.wrappedStyles();
        });
      });
    }
  };

  Drupal.behaviors.IEObjectFitLandingPageHero = {
    attach: function (context, settings) {
      $('.kr-landing-page-hero__content-wrapper', context).each(function () {
        IEObjectFit('.kr-landing-page-hero__background-image');
      });
    }
  };

  Drupal.behaviors.IEObjectFitLandingPagePartnerListing = {
    attach: function (context, settings) {
      $('.node--view-mode-featured node--kr-partner--feature', context).each(function () {
        IEObjectFit('.kr-partner-page-hero__background-image');
      });
    }
  };

})(jQuery, Drupal, drupalSettings);
